import { BottomSheet } from '../../../../../../components/Toolkit/BottomSheet/BottomSheet';
import { Button } from '../../../../../../components/Toolkit/Button';
import { FiltersV2 } from '../../../../../../features/filters/FiltersV2';
import { useFilterBottomSheet } from '../../../../../../components/SearchPage/features/QuickFilters/components/FilterBottomSheet/FilterBottomSheet.hook';
import { useQuickFilterContext } from '../../../../../../components/SearchPage/features/QuickFilters/QuickFilters.context';
import * as Styled from '../../../../../../components/SearchPage/features/QuickFilters/components/FilterBottomSheet/FilterBottomSheet.styled';
import type { FilterDisplayProps } from '../../../../../../components/SearchPage/features/QuickFilters/components/FilterBottomSheet/FilterBottomSheet.typed';
import { Spacer } from '../../../../../../helpers/genericStyles';
import { GroupedQuickFilters } from '../../GroupedQuickFilters/GroupedQuickFilters';

import { LocationFilter } from '../../../../../../features/filters/components/Location/Location';

import * as LocationStyled from '../../../../../../features/filters/Filters.styled';
import { GroupedFilterHeading } from '../../../../../../features/filters/components/Filter/GroupedFilterHeading/GroupedFilterHeading';

const FilterDisplay = (props: FilterDisplayProps) => {
  const { sectionName, subsectionName } = props;
  const {
    currentFilter,
    isFilterBottomSheetOpen: isOpen,
    onCloseFilterDisplay: askToClose,
  } = useQuickFilterContext();

  const {
    onClickDone,
    onClickClear,
    onChange,
    value,
    locationConfiguration,
    makeModelConfiguration,
    appliedFilterID,
    validPriceConfiguration,
  } = useFilterBottomSheet({
    askToClose,
  });

  if (!currentFilter) return null;

  const renderFilter = () => {
    if (currentFilter.type === 'group') {
      if (currentFilter.name === 'location') {
        return (
          <LocationStyled.LocationFilter>
            <LocationFilter
              {...locationConfiguration}
              displayLabel={false}
              heightVariant="LARGE"
            />
          </LocationStyled.LocationFilter>
        );
      }

      return (
        <GroupedQuickFilters
          sectionName={subsectionName}
          locationConfiguration={locationConfiguration}
          makeModelConfiguration={makeModelConfiguration}
          validPriceConfiguration={validPriceConfiguration}
          subfilters={currentFilter.subFilters}
        />
      );
    }

    return (
      <FiltersV2
        filter={{
          ...currentFilter,
          displayName: '',
          onChange,
          value,
        }}
        locationConfiguration={locationConfiguration}
        makeModelConfiguration={makeModelConfiguration}
        validPriceConfiguration={validPriceConfiguration}
        sectionName={sectionName}
      />
    );
  };

  return (
    <BottomSheet
      headerText={<GroupedFilterHeading filter={currentFilter} />}
      askToClose={askToClose}
      isOpen={isOpen}
      height=""
      variant="DIALOG"
    >
      {renderFilter()}
      <Spacer marginBottom={'M16'} />
      <Styled.ButtonContainer>
        <Button ofType="SECONDARY" onClick={onClickClear}>
          Clear
        </Button>
        <Button
          onClick={onClickDone}
          data-tracking={appliedFilterID}
          data-testid={'quick-filter-done'}
        >
          Done
        </Button>
      </Styled.ButtonContainer>
    </BottomSheet>
  );
};

export { FilterDisplay };
